import { activeCart } from '@/services/checkout';
import { setCookie } from 'cookies-next';

export function decodeJwt(token, fromServer = true) {
  if (!token) {
    return;
  }
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace('-', '+').replace('_', '/');
  if (!fromServer) {
    return JSON.parse(window.atob(base64));
  } else {
    return JSON.parse(Buffer.from(base64, 'base64').toString());
  }
}

export const countDownHandler = (toDate, fromDate) => {
  let timeLeft = { isCountDown: false };

  if (fromDate && new Date() <= new Date(fromDate)) {
    return timeLeft;
  }

  const difference = new Date(toDate) - new Date();

  if (difference > 0) {
    timeLeft = {
      isCountDown: true,
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / 1000 / 60) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    };
  }

  return timeLeft;
};

export const preventLettersInInput = (event) => {
  const input = event.key;
  // Allow control keys (e.g., backspace, delete)
  if (
    event.ctrlKey ||
    event.altKey ||
    event.metaKey ||
    input === 'Backspace' ||
    input === 'Delete'
  ) {
    return;
  }

  // Check if the input is not a number
  if (isNaN(Number(input))) {
    event.preventDefault();
  }
};

export function compareObjects(obj1, obj2) {
  // Get the keys of the objects
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  // Check if the number of keys is the same
  if (keys1.length !== keys2.length) {
    return false;
  }

  // Iterate over the keys and compare the values
  for (let key of keys1) {
    if (obj1[key] !== obj2[key]) {
      return false;
    }
  }

  // If all keys and values are equal, return true
  return true;
}

export function findObjectByIdV2(data, targetKey, searchValue) {
  if (data?.length) {
    for (const item of data) {
      if (item[targetKey] == searchValue) {
        // prettyConole(searchValue, item)
        return item;
      }

      if (item?.children_data && item?.children_data.length > 0) {
        const result = findObjectByIdV2(
          item?.children_data,
          targetKey,
          searchValue
        );
        if (result) {
          // prettyConole(searchValue, result)
          return result;
        }
      }
    }
  }
  // Target object not found
  return null;
}

/** Get 9-digit Saudi local part from any format (00966, 966, +966, 05…). */
function stripToNineDigits(value) {
  let s = (value ?? '').trim()
    .replace(/[\u0660-\u0669]/g, (d) => String.fromCharCode(d.charCodeAt(0) - 0x0660 + 0x30))
    .replace(/\D/g, '');
  if (s.startsWith('00966')) s = s.slice(5);
  else if (s.startsWith('966')) s = s.slice(3);
  if (s.startsWith('0')) s = s.slice(1);
  return s;
}

/** Format for backend: "00966" + 9 digits, or null if invalid. */
export function formatMobileForBackend(value) {
  return "00966" + value?.slice(-9);
}

/** Normalize for form display: 9 digits, no country code. */
export function normalizeMobileNumber(number) {
  return stripToNineDigits(number ?? '');
}

/** To display format: 0xxxxxxxx → +966xxxxxxxx */
export function denormalizeMobileNumber(number) {
  const s = number?.trim() ?? '';
  return s.startsWith('0') ? '+966' + s.slice(1) : s;
}

export function stripHTML(input) {
  let decodedValue = decodeURIComponent(input);
  return decodedValue.replace(/<\/?[^>]+(>|$)/g, ''); // Removes HTML tags
}

export const getDevicesKeys = (isMobile) => {
  const active = isMobile ? 'mobile-active' : 'active';
  const position = isMobile ? 'mobile-position' : 'position';
  return { active, position };
};

export const handleAddToActiveCart = async (
  handshake,
  order_id,
  push,
  locale
) => {
  const res = await activeCart(handshake, order_id);
  const cart_id = res?.data?.data?.cart_id;
  if (cart_id) {
    setCookie('quote', cart_id);
    setTimeout(() => {
      push(`/${locale}/cart`);
    }, 200);
  }
};

export const getErrorMessage = (payment, reason, locale) => {
  if (payment === 'tabby') {
    if (reason === 'Failure') {
      return locale?.includes('en')
        ? 'Sorry, Tabby is unable to approve this purchase. Please use an alternative payment method for your order.'
        : 'نأسف، تابي غير قادرة على الموافقة على هذه العملية. الرجاء استخدام طريقة دفع أخرى.';
    }
    return locale?.includes('en')
      ? 'You aborted the payment. Please retry or choose another payment method.'
      : 'لقد ألغيت الدفعة. فضلاً حاول مجددًا أو اختر طريقة دفع أخرى.';
  }
  return locale?.includes('en')
    ? 'Payment Failed, Please try again'
    : 'فشلت عملية الدفع, برجاء المحاولة مره اخرى';
};

export function unescapeHtml(escapedHtml) {
  const htmlEntities = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'",
  };

  return escapedHtml
    ?.replace(/&amp;|&lt;|&gt;|&quot;|&#39;/g, (match) => htmlEntities[match])
    ?.replaceAll('"{{media url="', `${process.env.NEXT_PUBLIC_IMG_BASEURL}/`)
    ?.replaceAll(`/media/" `, '/media/')
    ?.replaceAll('"}}"', '')
    ?.replaceAll(
      '{{media url=',
      `${process.env.NEXT_PUBLIC_IMG_BASEURL}/media/`
    )
    ?.replaceAll('}}', '');
}
